import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  quote: '"Tenía miedo de que fuera otra estafa, pero el contenido es súper profesional. Renuncié a mi trabajo administrativo porque gano más con las viandas en 3 días que en todo el mes de oficina."',
  name: '- Mariana P., Santa Fe',
  avatar: 'https://cdn.magicpatterns.com/uploads/r8zkJJaUFZcpeyYkWPZ12i/Captura_de_pantalla_2026-04-30_a_las_8.29.37_p._m..png'
}, {
  quote: '"La estrategia de \'vender antes de cocinar\' me salvó. Estaba en cero. Con la seña de los primeros 5 pedidos compré todo. Hoy tengo lista de espera."',
  name: '- Florencia D., Tucumán',
  avatar: 'https://cdn.magicpatterns.com/uploads/6bLH9aB3WsHg97kS5kQXtT/Captura_de_pantalla_2026-04-30_a_las_8.32.49_p._m..png'
}, {
  quote: '"Soy jubilada y pensé que no iba a entender lo digital. El paso a paso es clarísimo. Copio los mensajes de WhatsApp y vendo 40 viandas semanales sin esfuerzo."',
  name: '- Graciela M., CABA',
  avatar: 'https://cdn.magicpatterns.com/uploads/pRPhBy9NHrK7FzRbWKYYmv/Captura_de_pantalla_2026-04-30_a_las_8.32.55_p._m..png'
}, {
  quote: '"Increíble el módulo de costos. Me di cuenta de que estaba regalando mi trabajo. Ajusté precios, mejoré la presentación con el Kit y mis clientes me agradecieron la calidad."',
  name: '- Laura G., Buenos Aires',
  avatar: 'https://cdn.magicpatterns.com/uploads/4pnMr1uykbcuCzEgpKQU8B/Captura_de_pantalla_2026-04-30_a_las_8.33.01_p._m..png'
}, {
  quote: '"Estaba desorganizada y estresada. El sistema de producción en bloque me devolvió la vida. Cocino un solo día fuerte y listo. Negocio ordenado y rentable."',
  name: '- Martina S., Córdoba',
  avatar: 'https://cdn.magicpatterns.com/uploads/iMwnuvQHxUoQP764aYz3HB/Captura_de_pantalla_2026-04-30_a_las_8.33.07_p._m..png'
}];
export function TestimonialsText() {
  const [current, setCurrent] = useState(0);
  const prev = () => {
    setCurrent(c => (c - 1 + testimonials.length) % testimonials.length);
  };
  const next = () => {
    setCurrent(c => (c + 1) % testimonials.length);
  };
  const t = testimonials[current];
  return <section className="w-full bg-[#f9f8f4] px-4 md:px-8 py-16" data-id="element-346">
      <div className="max-w-[700px] mx-auto text-center" data-id="element-347">
        {/* Title */}
        <h2 className="font-['Playfair_Display',_serif] text-2xl md:text-3xl lg:text-[36px] font-bold text-[#1a1a1a] leading-tight mb-3 whitespace-nowrap" data-id="element-348">
          Ellas tomaron acción (y cambiaron su vida)
        </h2>
        <div className="w-16 h-1 bg-[#4caf50] mx-auto mb-6" data-id="element-349"></div>

        {/* Subtitle */}
        <p className="font-['Montserrat',_sans-serif] text-[#555] text-base md:text-lg mb-10" data-id="element-350">
          Dejaron las excusas, aplicaron el sistema y hoy facturan desde casa.
        </p>

        {/* Avatar */}
        <div className="flex justify-center mb-5" data-id="element-351">
          <div className="w-20 h-20 rounded-full overflow-hidden border-3 border-[#4caf50] bg-[#e8f5e2]" data-id="element-352">
            {t.avatar ? <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" data-id="element-353" /> : <div className="w-full h-full flex items-center justify-center text-3xl" data-id="element-354">
                👩‍🍳
              </div>}
          </div>
        </div>

        {/* Stars */}
        <div className="flex justify-center gap-1 text-xl mb-5" data-id="element-355">
          <span data-id="element-356">⭐</span>
          <span data-id="element-357">⭐</span>
          <span data-id="element-358">⭐</span>
          <span data-id="element-359">⭐</span>
          <span data-id="element-360">⭐</span>
        </div>

        {/* Quote */}
        <p className="font-['Montserrat',_sans-serif] text-[#374151] text-base md:text-lg italic leading-relaxed mb-4 px-4" data-id="element-361">
          {t.quote}
        </p>

        {/* Name */}
        <p className="font-['Montserrat',_sans-serif] text-[#1a1a1a] font-bold text-base md:text-lg mb-8" data-id="element-362">
          {t.name}
        </p>

        {/* Arrow Buttons */}
        <div className="flex justify-center gap-3" data-id="element-363">
          <button onClick={prev} className="w-11 h-11 rounded-full bg-[#4caf50] flex items-center justify-center hover:bg-[#43a047] transition-colors" aria-label="Testimonio anterior" data-id="element-364">
            <ChevronLeftIcon className="w-5 h-5 text-white" data-id="element-365" />
          </button>
          <button onClick={next} className="w-11 h-11 rounded-full bg-[#4caf50] flex items-center justify-center hover:bg-[#43a047] transition-colors" aria-label="Testimonio siguiente" data-id="element-366">
            <ChevronRightIcon className="w-5 h-5 text-white" data-id="element-367" />
          </button>
        </div>
      </div>
    </section>;
}